import { createFileRoute } from "@tanstack/react-router";
import Datenschutz from "@/pages/Datenschutz";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/datenschutz")({
  head: () =>
    seoHead({
      title: "Datenschutzerklärung | Clicks DMP",
      description:
        "Datenschutzerklärung der Website clicksdmp.com: Hosting, Cookies, Google Analytics nur mit Einwilligung, Anfrageformular, WhatsApp und Ihre Rechte.",
      path: "/datenschutz",
    }),
  component: Datenschutz,
});
